import { API_TEMPLATE } from '../libs/constant'
import { callDelete, get, patch, post, put } from '../libs/query'
import { formatUrl } from '../libs/url'
import { SESSION_URL_API } from 'src/libs/constant/session'

const sessionApi = {
  addNote ({ classId, note }) {
    return post(API_TEMPLATE.SESSION_ADD_NOTE, { classId, note })
  },
  addStudentToSlot (payload) {
    return post(API_TEMPLATE.SESSION_ADD_STUDENT, payload)
  },
  addStudentToSlotDemoFromReschedule (payload) {
    return post(API_TEMPLATE.SESSION_ADD_STUDENT_DEMO_FROM_RESCHEDULE, payload)
  },
  addStudentNote (payload) {
    return post(API_TEMPLATE.SESSION_ADD_STUDENT_COMMENT, payload)
  },
  assignTeacher ({ classDemoId, classTeacherSchedulerId }) {
    return post(`${API_TEMPLATE.SESSION_ASSIGN_TEACHER}?id=${classDemoId}&classTeacherSchedulerId=${classTeacherSchedulerId}`)
  },
  cancel (id) {
    return post(`${API_TEMPLATE.SESSION_CANCEL}?id=${id}`)
  },
  cancelMultipleBackupByTeacher (sessionIds) {
    return post(API_TEMPLATE.SESSION_CANCEL_BACKUP_MULTIPLE_BY_TEACHER, sessionIds)
  },
  cancelMultipleBackupByManager (sessionIds) {
    return post(API_TEMPLATE.SESSION_CANCEL_BACKUP_MULTIPLE_BY_MANAGER, sessionIds)
  },
  cancelMultipleByTeacher (sessionIds) {
    return post(API_TEMPLATE.SESSION_CANCEL_MULTIPLE_BY_TEACHER, sessionIds)
  },
  cancelMultipleByManager (sessionIds) {
    return post(API_TEMPLATE.SESSION_CANCEL_MULTIPLE_BY_MANAGER, sessionIds)
  },
  cancelClassSchedule (sessionIds) {
    return post(API_TEMPLATE.SESSION_CANCEL_TEACHER_SCHEDULE, sessionIds)
  },
  cancelTeacherSession (id) {
    return post(`${API_TEMPLATE.CALENDAR_CLASS_TEACHER_SCHEDULE_CANCEL}?id=${id}`)
  },
  createClassDemo (payload) {
    const path = API_TEMPLATE.SESSION_CREATE_CLASS_DEMO
    return post(path, payload)
  },
  getCharacteristicsParent ({ id, studentId }) {
    const path = `${API_TEMPLATE.SESSION_GET_PARENT_CHARACTERISTICS}/${id}/crm/${studentId}`
    return get(path)
  },
  getCharacteristicsProfileStudent (studentId) {
    const path = `${API_TEMPLATE.SESSION_GET_PARENT_CHARACTERISTICS}/crm/${studentId}`
    return get(path)
  },
  findClassDemoByStudentId (studentId) {
    return get(`${API_TEMPLATE.SESSION_CLASS_DEMO_BY_STUDENT}?studentId=${studentId}`)
  },
  createClassRegular (payload) {
    return post(
      `${API_TEMPLATE.SESSION_CREATE_CLASS_REGULAR}`, payload
    )
  },
  getClassRegularDetailById (id) {
    return get(`${API_TEMPLATE.CLASS_REGULAR_DETAIL}?id=${id}`)
  },
  createRegularSession (payload) {
    return post(API_TEMPLATE.SESSION_CREATE_REGULAR_SESSION, payload)
  },
  createRegularSessionInClass (payload) {
    return post(API_TEMPLATE.SESSION_CREATE_REGULAR_SESSION_IN_CLASS, payload)
  },
  detail (id) {
    return get(`${API_TEMPLATE.SESSION_ITEM}?id=${id}`)
  },
  detailWithStudentViewTaskMonitor (id) {
    return get(`${API_TEMPLATE.SESSION_ITEM_WITH_CHILDREN}?id=${id}&isViewTaskMonitor=true`)
  },
  detailWithStudent (id) {
    return get(`${API_TEMPLATE.SESSION_ITEM_WITH_CHILDREN}?id=${id}`)
  },
  detailWarningWithStudent (id) {
    return get(`${API_TEMPLATE.SESSION_ITEM_WITH_CHILDREN_WARNING}?id=${id}`)
  },
  savePlanStudent (payload) {
    const path = API_TEMPLATE.SAVE_PLAN_STUDENT
    return post(path, payload)
  },
  diligentInClass (sessionId) {
    return get(`${API_TEMPLATE.SESSION_DILIGENT_IN_CLASS}?sessionId=${sessionId}`)
  },
  detailLastSession (id) {
    return get(formatUrl(API_TEMPLATE.DETAIL_LAST_SESSION, [
      { key: 'id', value: id }
    ]))
  },
  getSessionAchievement (id) {
    return get(`${API_TEMPLATE.SESSION_GET_ACHIEVEMENT}/${id}/achievement`)
  },
  honorSessionAchievement (id) {
    return patch(`${API_TEMPLATE.SESSION_ACHIEVEMENT_HONOR}/${id}/achievement`)
  },

  getDetailLastExamSession (id) {
    return get(`${API_TEMPLATE.GET_DETAIL_LAST_EXAM_SESSION}/${id}/last-exam-session`)
  },

  exportClassDemo ({ payload, sheetId, sheetName }) {
    return post(`${API_TEMPLATE.SESSION_EXPORT_CLASS_DEMO}?sheetId=${sheetId}&sheetName=${sheetName || ''}`, payload)
  },
  exportRegularSession ({ payload, sheetId, sheetName }) {
    return post(`${API_TEMPLATE.SESSION_EXPORT_REGULAR}?sheetId=${sheetId}&sheetName=${sheetName}`, payload)
  },
  exportRegularSessionSummary ({ payload, sheetId, sheetName }) {
    return post(`${API_TEMPLATE.SESSION_EXPORT_REGULAR_SUMMARY}?sheetId=${sheetId}&sheetName=${sheetName}`, payload)
  },
  exportTeacherBook ({ payload, sheetId, sheetName }) {
    return post(`${API_TEMPLATE.SESSION_EXOPORT_TEACHER_BOOK}?sheetId=${sheetId}&sheetName=${sheetName}`, payload)
  },
  findTeacher (query) {
    return get(`${API_TEMPLATE.SESSION_FIND_TEACHER}?${query}`)
  },
  getChildrenByPhone (phone) {
    return get(`${API_TEMPLATE.SESSION_STUDENT_BY_PHONE}?phone=${phone}`)
  },
  getRegularTotalSummary ({ criteria }) {
    return post(API_TEMPLATE.SESSION_REGULAR_TOTAL_SUMMARY, { criteria })
  },
  getTotalSummary ({ criteria }) {
    return post(API_TEMPLATE.CALENDAR_TOTAL_SUMMARY, { criteria })
  },
  demoSessionByStudentAndDate ({ studentId, date }) {
    return get(`${API_TEMPLATE.SESSION_LIST_BY_DATE_STUDENT}?studentId=${studentId}&date=${date}`)
  },
  listClassSession ({ criteria, page, size }, queryString) {
    const path = API_TEMPLATE.SESSION_FILTER_CLASS
    return post(path, { criteria, page, size, sortOrders: queryString?.sortOrders })
  },
  listClassPending ({ criteria, page, size }) {
    const path = API_TEMPLATE.SESSION_FILTER_CLASS_PENDING
    return post(path, { criteria, page, size })
  },
  listCalendarClassRegular ({ criteria, page, size }) {
    const path = API_TEMPLATE.SESSION_FILTER_CALENDAR_CLASS_REGULAR
    return post(path, { criteria, page, size })
  },
  listClassRegular (payload, sortPayload = {}) {
    const path = API_TEMPLATE.SESSION_FILTER_CLASS_REGULAR
    return post(path, { ...payload, ...sortPayload })
  },
  listDemoSession ({ criteria, page, size }) {
    const path = API_TEMPLATE.SESSION_FILTER_DEMO
    return post(path, { criteria, page, size })
  },
  checkProportionArrangeClass ({ teacherId, type, ...rest }) {
    let param = `teacherId=${teacherId}&type=${type}`
    Object.keys(rest).forEach(item => rest[item] && (param = `${param}&${item}=${rest[item]}`))
    const path = `${API_TEMPLATE.CHECK_PROPORTION_ARRANGE_CLASS_DEMO}?${param}`
    return get(path)
  },

  listSessionsByClass (classId) {
    const path = API_TEMPLATE.SESSION_FILTER_REGULAR
    return post(path, {
      criteria: [{ field: 'classRegularId', operator: 'EQUAL', value: classId }],
      sortOrders: [
        {
          field: 'learnDate',
          isASC: false
        }
      ],
      page: 0,
      size: 50
    })
    // return post(`${API_TEMPLATE.SESSION_LIST_BY_CLASS}?classId=${classId}`)
  },
  listSessionRegular (payload) {
    return post(API_TEMPLATE.SESSION_FILTER_REGULAR, {
      ...payload,
      sortOrders: [
        {
          field: 'learnDate',
          isASC: false
        }
      ]
    })
  },
  listHomeWorkSessionRegular (payload) {
    return post(API_TEMPLATE.SESSION_FILTER_HOMEWORK, {
      ...payload,
      sortOrders: [
        {
          field: 'learnDate',
          isASC: false
        }
      ]
    })
  },
  listSession (payload, queryString) {
    return post(API_TEMPLATE.SESSION_FILTER_REGULAR, { ...payload, ...queryString })
  },
  listSessionMakeup (payload, queryString) {
    return post(API_TEMPLATE.SESSION_FILTER_REGULAR_MAKEUP, { ...payload, ...queryString })
  },
  listTeacherSession ({ criteria, page, size }) {
    const path = API_TEMPLATE.SESSION_FILTER_TEACHER
    return post(path, { criteria, page, size })
  },
  teacherScheduleFilter ({ criteria, page, size }, queryString) {
    const path = API_TEMPLATE.CALENDAR_CLASS_TEACHER_SCHEDULE
    return post(path, { criteria, page, size, sortOrders: queryString?.sortOrders })
  },
  registerTeacherSchedule ({ teacherId, fromDate, toDate, scheduleType }) {
    const path = `${API_TEMPLATE.CALENDAR_CLASS_TEACHER_SCHEDULE_REGISTER}?teacherId=${teacherId}&fromDate=${fromDate}&toDate=${toDate}&scheduleType=${scheduleType}`
    return get(path)
  },
  getClassRegularDetail ({ id }) {
    return get(`${API_TEMPLATE.SESSION_REGULAR_DETAIL}?${id}`)
  },
  listTeacherSessionCalendar ({ criteria, page, size }) {
    const path = API_TEMPLATE.CALENDAR_CLASS_TEACHER_SCHEDULE
    return post(path, { criteria, page, size })
  },
  classScheduleSlotByType (scheduleType) {
    const path = API_TEMPLATE.CALENDAR_GET_CLASS_SCHEDULE_BY_SCHEDULE_TYPE
    return post(`${path}?scheduleType=${scheduleType}`, {})
  },
  listTeacherSessionByAssignedrate ({ criteria, page, size }) {
    return post(API_TEMPLATE.SESSION_LIST_TEACHER_BY_ASSIGNED_RATE, {
      criteria,
      page,
      size
    })
  },
  listDeduplicatedTeacherSession ({ criteria, page, size }) {
    const path = API_TEMPLATE.SESSION_FILTER_TEACHER_DEDUPLICATED
    return post(path, { criteria, page, size })
  },
  open ({ teacherSchedules, teacherId, scheduleType }) {
    const path = API_TEMPLATE.SESSION_OPEN
    return post(`${path}?teacherId=${teacherId}`, {
      scheduleType,
      teacherSchedules
    })
  },
  openBackup ({ plans, teacherId }) {
    const path = API_TEMPLATE.SESSION_OPEN_BACKUP
    return post(path, { plans, teacherId })
  },
  openFollowPlan (payload) {
    return post(API_TEMPLATE.SESSION_OPEN_FOLLOW_PLAN, payload)
  },
  removeStudent ({ classId, studentId }) {
    return callDelete(`${API_TEMPLATE.SESSION_REMOVE_STUDENT}?classId=${classId}&studentId=${studentId}`)
  },
  restoreTeacherSession (id) {
    return post(`${API_TEMPLATE.SESSION_TEACHER_RESTORE}?id=${id}`)
  },
  teacherConfirm ({ id }) {
    const path = formatUrl(API_TEMPLATE.SESSION_TEACHER_CONFIRM, [{ key: 'id', value: id }])
    return post(path)
  },

  teacherDecline ({ id }) {
    const path = formatUrl(API_TEMPLATE.SESSION_TEACHER_DECLINE, [{ key: 'id', value: id }])
    return post(path)
  },
  teacherOpen ({ teacherSchedules, scheduleType }) {
    const path = API_TEMPLATE.SESSION_TEACHER_OPEN
    return post(path, { teacherSchedules, scheduleType })
  },
  teacherOpenBackup ({ plans }) {
    const path = API_TEMPLATE.SESSION_TEACHER_OPEN_BACKUP
    return post(path, { plans })
  },
  update (payload) {
    return post(API_TEMPLATE.SESSION_ADD_STUDENT, payload)
  },
  move (payload) {
    return post(API_TEMPLATE.SESSION_MOVE_STUDENT, payload)
  },
  updateStudent (payload) {
    return post(API_TEMPLATE.SESSION_UPDATE_STUDENT, payload)
  },
  updateNoteStudent (payload) {
    return post(API_TEMPLATE.SESSION_UPDATE_NOTE_STUDENT, payload)
  },
  studentsInSession (query) {
    return get(`${API_TEMPLATE.SESSION_STUDENT_IN_SESSION}?sessionId=${query}`)
  },
  deleteStudentInSession ({ classRegularSessionId, studentId }) {
    return post(
      `${API_TEMPLATE.SESSION_DELETE_STUDENT}?classRegularSessionId=${classRegularSessionId}&studentId=${studentId}`
    )
  },
  addCommentSession (payload) {
    return post(API_TEMPLATE.ADD_COMMENT_SESSION, payload)
  },
  editSession (payload) {
    return put(API_TEMPLATE.EDIT_SESSION, payload)
  },
  monitorOfSession (query) {
    return get(`${API_TEMPLATE.MONITOR_OF_SESSION}?id=${query}`)
  },
  listTeacherSchedule (payload, queryString) {
    return post(API_TEMPLATE.SESSION_LIST_SCHEDULE_TEACHER, { ...payload, ...queryString })
  },
  listTeacherRegisteredSchedule (payload, queryString) {
    return post(API_TEMPLATE.SESSION_LIST_SCHEDULE_REGISTERED_TEACHER, { ...payload, ...queryString })
  },
  listCreateMakeupLesson (payload, queryString) {
    return post(API_TEMPLATE.SESSION_LIST_SCHEDULE_TEACHER_MAKE_UP_LESSON, { ...payload, ...queryString })
  },
  listLearnDate (payload, queryString) {
    return post(API_TEMPLATE.SESSION_LIST_LEARN_DATE, { ...payload, ...queryString })
  },
  listFirstSchedule (payload, queryString) {
    return post(API_TEMPLATE.SESSION_LIST_FIRST_SCHEDULE, { ...payload, ...queryString })
  },
  listSecondSchedule (payload, queryString) {
    return post(API_TEMPLATE.SESSION_LIST_SECOND_SCHEDULE, { ...payload, ...queryString })
  },
  listTeacherScheduleNStudyProgram (payload, queryString) {
    return post(API_TEMPLATE.SESSION_LIST_SCHEDULE_TEACHER_MULTIPLE_SESSION, { ...payload, ...queryString })
  },
  addClassRegularMultiSchedules (payload) {
    return post(API_TEMPLATE.CREATE_CLASS_REGULAR_WITH_MULTI_SCHEDULES, payload)
  },
  listTeacherScheduleMultiSessionsPerWeek (payload, queryString) {
    return post(API_TEMPLATE.LIST_TEACHER_SCHEDULE_MULTI_SESSIONS_PER_WEEK, { ...payload, ...queryString })
  },
  listTeacherScheduleByClassiFy (payload) {
    return post(API_TEMPLATE.CLASS_TEACHER_LIST_SCHEDULE_TEACHER_BY_CLASSIFY, payload)
  },
  addStudentSession (payload) {
    return post(API_TEMPLATE.ADD_STUDENT_SESSION, payload)
  },
  studyProgramOfSession (query) {
    return get(`${API_TEMPLATE.CONFIG_GET_STUDY_PROGRAM_DETAIL}/${query}`)
  },
  detailSessionWithChildrenByCode (code) {
    return get(`${API_TEMPLATE.SESSION_CODE_WITH_CHILDREN}?code=${code}`)
  },
  listTicketMakeupSession (payload, queryString) {
    return post(API_TEMPLATE.LIST_TICKET_MAKEUP_SESSION, { ...payload, ...queryString })
  },
  addStudentMakeupSession (payload) {
    return post(API_TEMPLATE.ADD_STUDENT_MAKEUP_SESSION, payload)
  },
  createMakeupSession (payload) {
    return post(API_TEMPLATE.CREATE_MAKEUP_SESSION, payload)
  },
  ticketMakeupSessionDetail (id) {
    return get(`${API_TEMPLATE.TICKET_MAKEUP_SESSION_DETAIL}?id=${id}`)
  },
  assignCoorMakeupSession ({ userId, arrangeId }) {
    return post(`${API_TEMPLATE.MAKEUP_SESSION_ARRANGE_CLASS_ASSSIGN}?taskId=${arrangeId}&userId=${userId}`)
  },
  changeCallStatusMakeupSession ({ callStatus, arrangeId }) {
    return post(
      `${API_TEMPLATE.MAKEUP_SESSION_CHANGE_CALL_STATUS}?id=${arrangeId}&status=${callStatus}`
    )
  },
  assignCoorMultipleMakeupSession (payload) {
    return post(API_TEMPLATE.MAKEUP_SESSION_COOR_MULTIPLE, payload)
  },
  exportMakeupSession ({ payload, sheetId, sheetName }) {
    return post(
      `${API_TEMPLATE.MAKEUP_SESSION_EXPORT}?sheetId=${sheetId}&sheetName=${sheetName}`,
      payload
    )
  },
  getLinkLoginClassInBySessionId (sessionId) {
    return get(
      `${API_TEMPLATE.GET_LINK_LOGIN_CLASS_IN_BY_SESSION_ID}?sessionId=${sessionId}`
    )
  },
  assignMultipleMakeupSession (payload) {
    return post(`${API_TEMPLATE.MAKEUP_SESSION_ASSIGN_MULTIPLE}`, payload)
  },
  addNotesMakeupSession (payload) {
    return post(`${API_TEMPLATE.MAKEUP_SESSION_ADD_NOTES}`, payload)
  },

  listWaitingConfirm (payload, queryString) {
    return post(API_TEMPLATE.WAITING_CONFIRM_LIST, {
      ...payload,
      ...queryString,
    })
  },

  getDataHomework (id) {
    return get(`${API_TEMPLATE.SESSION_DATA_HOMEWORK}?sessionId=${id}`)
  },
  getSpeakingGradeDataHomework () {
    return get(`${API_TEMPLATE.GET_SPEAKING_GRADE_SESSION_DATA_HOMEWORK}`)
  },
  createSpeakingHomework (payload) {
    return post(`${API_TEMPLATE.CREATE_SESSION_DATA_HOMEWORK}`, payload)
  },
  updateSpeakingHomework (payload) {
    return post(`${API_TEMPLATE.UPDATE_SESSION_DATA_HOMEWORK}`, payload)
  },
  findSpeakingHomework (payload) {
    return post(`${API_TEMPLATE.FIND_SESSION_DATA_HOMEWORK}`, payload)
  },

  filterReceiveBackup ({ criteria, page, size }, queryString) {
    const path = API_TEMPLATE.FILTER_RECEIVE_BACKUP
    return post(path, { criteria, page, size, sortOrders: queryString?.sortOrders })
  },
  receiveBackup (id) {
    return post(`${API_TEMPLATE.RECEIVE_BACKUP}?id=${id}`)
  },

  getRegisterDutyBackup ({ learnDateFrom, learnDateTo }) {
    const path = API_TEMPLATE.GET_REGISTER_DUTY_SCHEDULE
    return get(`${path}?learnDateFrom=${learnDateFrom}&learnDateTo=${learnDateTo}`)
  },
  createRegisterDutyBackup (payload) {
    return put(`${API_TEMPLATE.UPDATE_REGISTER_DUTY_SCHEDULE}`, payload)
  },
  filterRegisterDutyBackup (payload) {
    return post(`${API_TEMPLATE.FILTER_REGISTER_DUTY_SCHEDULE}`, payload)
  },
  filterListSLotDutyBackup (payload, queryString) {
    return post(`${API_TEMPLATE.FILTER_LIST_SLOT_DUTY_BACKUP}`, {
      ...payload,
      sortOrders: queryString?.sortOrders || []
    })
  },
  updateCallStatusBackup ({ id, statusCall }) {
    return patch(`${API_TEMPLATE.UPDATE_CALL_STATUS_BACKUP}`, { id, callStatus: statusCall })
  },
  getSessionBackupOption ({ learnDate, classTimeSlotId }) {
    return get(`${API_TEMPLATE.GET_SESSION_BACKUP_OPTION}?learnDate=${learnDate}&classTimeSlotId=${classTimeSlotId}`)
  },
  updateSessionBackup ({ id, sessionId }) {
    return patch(`${API_TEMPLATE.UPDATE_SESSION_BACKUP}/${id}/session-id/${sessionId}`)
  },
  removeSessionBackup ({ id }) {
    const path = formatUrl(API_TEMPLATE.REMOVE_SESSION_BACKUP, [{ key: 'id', value: id }])
    return patch(path)
  },
  receiveDutySessionBackup ({ id, teacherId }) {
    return patch(`${API_TEMPLATE.UPDATE_SESSION_BACKUP}/${id}/confirm?teacherId=${teacherId}`)
  },
  attendanceSessionBackup (id) {
    return patch(`${API_TEMPLATE.UPDATE_SESSION_BACKUP}/${id}/attendance`)
  },
  getTeacherBackupOption ({ learnDate, classTimeSlotId }) {
    return get(`${API_TEMPLATE.GET_TEACHER_BACKUP_OPTION}?learnDate=${learnDate}&classTimeSlotId=${classTimeSlotId}`)
  },
  updateCancelMonitorBackup ({ id, ...payload }) {
    return post(`${API_TEMPLATE.UPDATE_CANCEL_MONITOR_BACKUP}/${id}`, payload)
  },
  exportGGSheetTaskObserveBackup ({ payload, sheetId, sheetName }) {
    return post(
      `${API_TEMPLATE.EXPORT_GOOGLE_SHEET_MONITOR_BACKUP}?sheetId=${sheetId}&sheetName=${sheetName}`,
      payload
    )
  },

  //api today class schedule
  getHomeWorkStudent ({ studentId, classRegularSessionId, type }) {
    const path = `${API_TEMPLATE.SESSION_GET_HOME_WORK_STUDENT}?studentId=${studentId}&classRegularSessionId=${classRegularSessionId}&type=${type}`
    return get(path)
  },
  getSessionNearest () {
    const path = API_TEMPLATE.GET_SESSION_NEAREST
    return get(path)
  },
  updateTimeStatusExercise (payload) {
    const path = `${API_TEMPLATE.UPDATE_TIME_STATUS_EXERCISE}`
    return post(path, payload)
  },
  getStudentPromotionCheck (id) {
    const path = `${API_TEMPLATE.GET_STUDENT_PROMOTION_CHECK}/${id}/promotion-check`
    return get(path)
  },

  getDetailLastExamSession (id) {
    return get(`${API_TEMPLATE.GET_DETAIL_LAST_EXAM_SESSION}/${id}/last-exam-session`)
  },

  getFolder (id) {
    const path = formatUrl(API_TEMPLATE.FOLDER_CLASSIN, [{ key: 'id', value: id }])
    return get(path)
  },

  getMuster (id) {
    return get(API_TEMPLATE.GET_MUSTER, { id })
  },

  postMuster (payload) {
    const path = API_TEMPLATE.POST_MUSTER
    return post(path, payload)
  },
  getTeacherByStudentId (id) {
    const path = formatUrl(API_TEMPLATE.GET_TEACHER_SESSION, [{ key: 'id', value: id }])
    return get(path)
  },
  getPrevReward (id) {
    const path = formatUrl(API_TEMPLATE.GET_PREV_REWARD, [{ key: 'id', value: id }])
    return get(path)
  },
  assignCoordinator ({ id, coordinatorId }) {
    let path = `${SESSION_URL_API.ASSIGN_COORDINATOR}?id=${id}`
    if (coordinatorId) {
      path += `&coordinatorId=${coordinatorId}`
    }
    return patch(path)
  },
  divideMultipleClassDemo (payload) {
    return post(`${API_TEMPLATE.CLASS_DIVIDE_MULTIPLE_CLASS_DEMO}`, payload)
  },
  divideMultipleClassRegular (payload) {
    return post(`${API_TEMPLATE.CLASS_DIVIDE_MULTIPLE_CLASS_REGULAR}`, payload)
  },
}

export default sessionApi
